import React, { useMemo } from 'react'
import {
    BotaoTwoCard,
    ContainerList,
    Imagem1,
    Imagem2,
    InnerContainerListaPassoAPasso,
    LeftArrow,
    RightArrow,
} from '../styles'
import Slider from 'react-styled-carousel'
import { DotBlueGray } from '../../../layouts/Default'
import Card from '../../Card'
import BotaoCTA from '../..//BotaoCTA'

const TwoCardsMobile = ({
    tamanhoListaCards,
    imagem,
    imagemAux,
    responsive,
    listaDeCards,
    botao,
    id,
}) => {
    const lista = useMemo(() => {
        return listaDeCards.map((item) => (
            <div className={`card-list-item${id}`} key={id}>
                <Card
                    tamanhoListaCards={tamanhoListaCards}
                    card={item}
                    key={item.id}
                    transparent
                />
            </div>
        ))
    }, [id, listaDeCards, tamanhoListaCards])
    return (
        <ContainerList tamanhoListaCards={tamanhoListaCards}>
            <InnerContainerListaPassoAPasso>
                {imagem && <Imagem1 src={imagem} />}
                {imagemAux && <Imagem2 src={imagemAux} />}
                <Slider
                    draggable={false}
                    showArrows
                    showDots={window.innerWidth < 768}
                    autoSlide={false}
                    responsive={responsive}
                    ssr
                    infinite={false}
                    autoPlay={false}
                    Dot={<DotBlueGray />}
                    keyBoardControl
                    LeftArrow={<LeftArrow src="/parcerias/assets/chevron-left-turquoise.png" />}
                    RightArrow={<RightArrow src="/parcerias/assets/chevron-right-turquoise.png" />}
                    padding="0"
                >
                    {lista}
                </Slider>
            </InnerContainerListaPassoAPasso>
            {botao && (
                <BotaoTwoCard>
                    <BotaoCTA botao={botao} />
                </BotaoTwoCard>
            )}
        </ContainerList>
    )
}

export default TwoCardsMobile
